import { useResizeObserver as H } from "@vueuse/core";
import { defineComponent as P, ref as k, computed as i, reactive as J, toRef as K, watch as Q, nextTick as N, onMounted as U, resolveComponent as b, openBlock as n, createElementBlock as r, normalizeClass as S, createElementVNode as B, Fragment as d, renderList as C, createBlock as W, withModifiers as V, withCtx as g, renderSlot as z, createTextVNode as A, toDisplayString as G, createVNode as $, createCommentVNode as j, withDirectives as Y, vShow as Z } from "vue";
import { useProxyModelValue as _ } from "@onereach/ui-components-common/hooks";
import { O as x } from "./OrIcon-k8cyvh-D.mjs";
import { O as ee } from "./OrMenuItem-BHRMA0L1.mjs";
import { O as oe } from "./OrMenu-CJT4Snay.mjs";
import { O as te } from "./OrTab-BdtxL_PY.mjs";
import { _ as ne } from "./_plugin-vue_export-helper-CHgC5LLL.mjs";
var D = /* @__PURE__ */ ((e) => (e.Default = "default", e.Fitted = "fitted", e))(D || {}), c = /* @__PURE__ */ ((e) => (e.MD = "md", e.LG = "lg", e.XL = "xl", e))(c || {});
const le = [
  // Layout
  "layout-column",
  "grow",
  // Box
  "h-full"
], re = {
  [c.MD]: [
    // Spacing
    "gap-md"
  ],
  [c.LG]: [
    // Spacing
    "gap-lg"
  ],
  [c.XL]: [
    // Spacing
    "gap-xl"
  ]
}, ae = [
  // Layout
  "grid grid-flow-col items-center shrink-0",
  // Theme
  "theme-border-outline border-b-1",
  "dark:theme-border-outline"
], ie = {
  default: [
    // Layout
    "auto-cols-max",
    // Spacing
    "gap-lg"
  ],
  fitted: [
    // Layout
    "auto-cols-auto",
    // Spacing (children)
    "children:px-lg"
  ]
}, se = [
  // Layout
  "layout-column",
  "grow",
  // Box
  "h-full",
  // Overflow
  "overflow-auto"
], ue = P({
  name: "OrTabs",
  components: {
    OrIcon: x,
    OrMenu: oe,
    OrMenuItem: ee,
    OrTab: te
  },
  model: {
    prop: "modelValue",
    event: "update:modelValue"
  },
  props: {
    modelValue: {
      type: [String, Number],
      default: void 0
    },
    items: {
      type: Array,
      required: !0
    },
    spacing: {
      type: String,
      default: c.LG
    },
    variant: {
      type: String,
      default: () => D.Default
    },
    keepAlive: {
      type: Boolean,
      default: !1
    }
  },
  emits: [
    "update:modelValue"
  ],
  expose: [
    "root"
  ],
  setup(e, f) {
    const s = k(), h = k(), R = i(() => {
      var t;
      return (t = h.value) == null ? void 0 : t.root;
    }), T = k(), m = i(() => {
      var t;
      return (t = T.value) == null ? void 0 : t.root;
    }), y = i(() => [
      ...le,
      ...re[e.spacing]
    ]), O = i(() => [
      "or-tabs-v3",
      ...ae,
      ...ie[e.variant]
    ]), M = i(() => [
      ...se
    ]), o = J({
      normal: [],
      hidden: []
    }), l = _(K(e, "modelValue"), f.emit), w = i(() => e.items.find(({ value: t }) => t === l.value));
    function F(t) {
      t.disabled || (l.value = t.value);
    }
    function I(t, v, u) {
      const { children: q } = u, p = [...t], a = [];
      let L = u.scrollWidth;
      return [...q].reverse().forEach((E) => {
        L > u.clientWidth && (a.unshift(p.pop()), L -= E.clientWidth + (e.variant === D.Default ? 16 : 0));
      }), a.includes(v) && (a.unshift(p.pop()), p.push(...a.splice(a.indexOf(v), 1))), {
        normal: p,
        hidden: a
      };
    }
    function X(t) {
      return e.keepAlive || l.value === t;
    }
    return Q([
      () => e.items,
      w,
      s
    ], ([
      t,
      v,
      u
    ]) => {
      o.normal = t, N(() => {
        Object.assign(o, I(t, v, u));
      });
    }), H(s, () => {
      o.normal = e.items, N(() => {
        Object.assign(o, I(e.items, w.value, s.value));
      });
    }), U(() => {
      var t;
      l.value || (l.value = (t = e.items[0]) == null ? void 0 : t.value);
    }), {
      root: s,
      overflowTab: h,
      overflowTabRoot: R,
      overflowMenu: T,
      overflowMenuRoot: m,
      containerStyles: y,
      rootStyles: O,
      contentStyles: M,
      tabs: o,
      proxyModelValue: l,
      activeTab: w,
      selectTab: F,
      isTabRendered: X
    };
  }
});
function de(e, f, s, h, R, T) {
  const m = b("OrTab"), y = b("OrIcon"), O = b("OrMenuItem"), M = b("OrMenu");
  return n(), r("div", {
    class: S(e.containerStyles)
  }, [
    B("div", {
      ref: "root",
      class: S(e.rootStyles)
    }, [
      (n(!0), r(d, null, C(e.tabs.normal, (o) => (n(), W(m, {
        key: o.value,
        selected: o.value === e.proxyModelValue,
        invalid: o.invalid,
        disabled: o.disabled,
        onClick: V((l) => e.selectTab(o), ["stop"])
      }, {
        default: g(() => [
          z(e.$slots, "tab", {
            tab: o,
            activeTab: e.activeTab
          }, () => [
            A(G(o.label), 1)
          ])
        ]),
        _: 2
      }, 1032, ["selected", "invalid", "disabled", "onClick"]))), 128)),
      e.tabs.hidden.length > 0 ? (n(), r(d, { key: 0 }, [
        $(m, {
          ref: "overflowTab",
          onClick: f[0] || (f[0] = V((o) => e.overflowMenu && e.overflowMenu.toggle(), ["stop"]))
        }, {
          default: g(() => [
            $(y, {
              icon: "more_horiz",
              variant: "filled-bold"
            })
          ]),
          _: 1
        }),
        $(M, {
          ref: "overflowMenu",
          trigger: e.overflowTabRoot
        }, {
          default: g(() => [
            (n(!0), r(d, null, C(e.tabs.hidden, (o) => (n(), W(O, {
              key: o.value,
              disabled: o.disabled,
              onClick: V((l) => {
                e.selectTab(o), e.overflowMenu && e.overflowMenu.close();
              }, ["stop"])
            }, {
              default: g(() => [
                A(G(o.label), 1)
              ]),
              _: 2
            }, 1032, ["disabled", "onClick"]))), 128))
          ]),
          _: 1
        }, 8, ["trigger"])
      ], 64)) : j("", !0)
    ], 2),
    B("div", {
      class: S(e.contentStyles)
    }, [
      (n(!0), r(d, null, C(e.items, (o) => (n(), r(d, null, [
        e.isTabRendered(o.value) ? Y((n(), r("div", {
          key: o.value,
          class: "contents"
        }, [
          z(e.$slots, String(o.value))
        ])), [
          [Z, String(e.proxyModelValue) === String(o.value)]
        ]) : j("", !0)
      ], 64))), 256))
    ], 2)
  ], 2);
}
const Te = /* @__PURE__ */ ne(ue, [["render", de]]);
export {
  Te as O,
  D as T,
  c as a
};
//# sourceMappingURL=OrTabs-BUXLSz8o.mjs.map
